// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"MyProfileForm__wrapper__n3Sw6","submitResult":"MyProfileForm__submitResult__ozcW1","actionWrapper":"MyProfileForm__actionWrapper__E3QXt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MyProfileForm/MyProfileForm.css
// module id = 1849
// module chunks = 0